import React from 'react';
import {
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';
import * as constants from '../../config/constants';


const footer = () => {
  const isAnjalAvsar = window.location.host.includes('anjalavsar.com');

  const date = new Date().getFullYear();

  const sites = constants.SITES.map((val) => {
    return (
      <React.Fragment key={val[0]}>
        <a href={`//${val[0]}`}><Typography style={{ fontSize: '16px' }} variant="body1">{val[1]}</Typography></a>
      </React.Fragment>
    );
  });

  return isAnjalAvsar ? (
    <div className={classes.footerWrapper}>
      <div className={classes.container}>
        <Grid container spacing={16}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="subheading"><b>Disclaimer</b></Typography>
            <br />
            <Typography variant="body1">
              {'We are a Lohana (Gujarati) community private matrimony service. To specify we do not charge any amount and we do not accept any direct or indirect favors from anyone. Currently Mr. Jayendra Sodha and his supporting well wishers, almost all business class people and of high society, ready to serve society without any selfish motive.'}
            </Typography>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid container spacing={16}>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>General</b></Typography>
            <br />
            <Typography variant="subheading">
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'about' })}>
                About
              </Link> <br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'services' })}>
                Services
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'team' })}>
                Team
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'contact' })}>
                Contact Us
              </Link>
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Other Anjal ane Avsar Websites</b></Typography> <br />
            {sites}
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Contact Us</b></Typography>
            <br />
            <Typography variant="subheading">
              +91 9869009363 | +91 22 26630152 <br />
              jayendrarsodha@rediffmail.com <br />
              Contact Timings: <br /> Monday to Friday, 11:00 to 1:00 PM
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Support</b></Typography>
            <br />
            <Typography variant="subheading">
              Tech Support only by email
              <br />
              support@anjalavsar.com
            </Typography>
          </Grid>
        </Grid>
        <br /><br />
        <Divider />
        <div align="center" className={classes.padding10}>
          <Typography variant="body1">
            Copyright&nbsp; <i className="far fa-copyright" />&nbsp; {date} &nbsp;Anjal ane Avsar <br />
          </Typography>
        </div>
      </div>
    </div>
  ) : (
    <div className={classes.footerWrapper}>
      <div className={classes.container}>
        <Grid container spacing={16}>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>General</b></Typography>
            <br />
            <Typography variant="subheading">
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'about' })}>
                About
              </Link> <br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'services' })}>
                Services
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'team' })}>
                Team
              </Link><br />
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'contact' })}>
                Contact Us
              </Link>
              <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'privacy-policy' })}>
                Privacy Policy
              </Link>
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Contact Us - Shaadiyog.in</b></Typography>
            <br />
            <Typography variant="subheading">
              +91 9820133160<br />
              jayeshkhemka7@gmail.com <br />
              Contact Timings: <br /> Monday to Friday, 11:00 to 1:00 PM
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Contact Us - Anjal ane Avsar</b></Typography>
            <br />
            <Typography variant="subheading">
              +91 9869009363 | +91 22 26630152 <br />
              jayendrarsodha@rediffmail.com <br />
              Contact Timings: <br /> Monday to Friday, 11:00 to 1:00 PM
            </Typography>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Typography variant="subheading"><b>Support</b></Typography>
            <br />
            <Typography variant="subheading">
              Tech Support only by email
              <br />
              support@anjalavsar.com
            </Typography>
          </Grid>
        </Grid>
        <br /><br />
        <Divider />
        <div align="center" className={classes.padding10}>
          <Typography variant="body1">
            Copyright&nbsp; <i className="far fa-copyright" />&nbsp; {date} &nbsp;Shaadiyog <br />
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/common/components/Footer.js